import { Building, CircleAlert } from 'lucide-react'
import { use } from 'react'
import { CompanySuspensionContext } from '@/components/company-suspension/context'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useRBAC } from '@/lib/hooks'

export const FraudSuspensionNotice = () => {
  const { rbac } = useRBAC()
  const { isSuspended, suspensionReason } = use(CompanySuspensionContext)

  if (
    !isSuspended ||
    suspensionReason !== 'fraud' ||
    !rbac.kinsta().superadmin.can()
  ) {
    return null
  }

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Company suspended for fraudulent activity"
            className="relative cursor-default hover:bg-transparent focus:bg-transparent"
          >
            <Building className="size-4 text-muted-foreground" />
            <CircleAlert className="absolute bottom-1 right-1 size-3.5 fill-warning stroke-background" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          This company is suspended for fraudulent activity!
        </TooltipContent>
      </Tooltip>
      <Separator orientation="vertical" className="h-4!" />
    </>
  )
}
